const UiPaths = {
  Dashboard:           '/dashboard/:id',
  Login:               'login',
  Signup:              'signup',
  ForgotPassword:      'forgot-password',
  ResetPassword:       'reset-password/:token',
  AdminUsers:          '/admin/users',
  ProductGroup:        '/productgroup/:type',
  SmartAnalytics:      '/smart-analytics',
  StockIntelligence:   '/stock-intelligence',
  InventoryControl:    '/inventory-control',
  SkuAssociation:      '/sku-association',
  PricingIntelligence: '/pricing-intelligence',
  BuyingDecisions:     '/buying-decisions',
  Marjan:              '/marjan',
  MarjanSkuAssociation: '/marjan/sku-association',
  ProductRadar:        '/product-radar',
  NetProfit:           '/net-profit',
  Warehouse:           '/warehouse',
  BundlesStudio:       '/bundles-studio',
  Sizes:               '/sizes',
  PhotoBank:           '/photo-bank',
  OrdersToday:         '/orders',
  ShoppingList:        '/shopping-list',
  SupplyPlan:          '/supply-plan',
  SupportTickets:      '/support-tickets',
  ProductListing:      '/listing',
  Returns:             '/returns',
  ListingOpportunities: '/listing-opportunities',
  Decisions:           '/decisions',
  Promotions:          '/promotions',
  PartnerStatements:   '/partner-statements',
  MyTasks:             '/my-tasks',
  SystemHealth:        '/system-health',
  TelegramScout:       '/telegram-scout',
  Scanner:             '/scanner',
  DailyShipments:      '/daily-shipments',
  MyStore:             '/my-store',
};

export default UiPaths;
